// extracted by mini-css-extract-plugin
export default {"blockwrapper":"fV","header":"gV","name":"hV","columns":"iV","imagewrapper":"jV","addinfo":"kV","description":"lV","price":"mV","old":"nV","new":"oV","desc_d":"pV","infoblock":"qV","desc_m":"rV"};
    if(module.hot) {
      // 1738836197914
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  